import { MONTHS } from "../../../../constants/options";
import React from "react";
import { DatePart } from "./datePart";

export const DateMonth = ({name, month, ariaLabel, handleChange, handleBlur, errors, touched}) => {
  return (
    <DatePart
      name={name}
      dayMonthOrYear="month"
      ariaLabel={ariaLabel}
      value={month}
      handleChange={handleChange}
      handleBlur={handleBlur}
      errors={errors}
      touched={touched}
      options={MONTHS}
    />
  )
};